<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
    :fill="color"
  >
    <title>logout</title>
    <path
      fill="none"
      stroke-linejoin="miter"
      stroke-linecap="butt"
      stroke-miterlimit="4"
      stroke-width="2.6667"
      :stroke="color"
      d="M18.663 4.639h-12.781c-1.569 0-2.84 1.272-2.84 2.84v17.041c0 1.569 1.272 2.84 2.84 2.84h12.781"
    />
    <path d="M28.248 14.225v2.84h-17.041v-2.84h17.041z" />
    <path
      fill="none"
      stroke-linejoin="miter"
      stroke-linecap="butt"
      stroke-miterlimit="4"
      stroke-width="2.6667"
      :stroke="color"
      d="M23.988 10.675l4.97 4.97-4.97 4.97"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgTalk',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>

<style>

</style>
